import React from 'react'
import Text from 'react-text'
import {Link} from 'react-router-dom'
import {Consumer} from '../../../../context'
import SearchPattern from '../search-pattern'
import StudentsTable from './table'
import Filters from './filter'
import {faFilter} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import '../../../back-button/back-button.styl'
import './students.styl'

export default function Students () {
return (
  <Consumer>{ (context) => {
    const backPath= context.link({}, "/:languageId/:role/:page/groups", {preserveQuery: false})
    const notDownloaded = context.query.notDownloaded == 'true'
    const changeNotDownloaded = (e) => {
      const query = {notDownloaded: !notDownloaded || undefined, page: undefined}
      context.navigate({}, context.match.path, {preserveQuery: true, query})
    }
    return (
      <div className="monitoring students">
        <div className="content">
          <div className="filters">
            <Link className="back-button" to={backPath} />
            <div className="filler" />
            <SearchPattern initialPattern={context.query.pattern || ""}/>
          </div>
          <StudentsTable />
        </div>
        <div className="filters">
          <div className="head">
            <span className="icon">
              <FontAwesomeIcon icon={faFilter} />
            </span>
            <span className="label">
              <Text id="filters_label" />
            </span>
          </div>
          <Filters />
          <div className="not-downloaded">
            <label>
              <span className="checkbox">
                <input type="checkbox" {...{checked: notDownloaded}} onChange={changeNotDownloaded} />
              </span>
              <span className="label">
                <Text id="not_downloaded_label" />
              </span>
            </label>
          </div>
        </div>
      </div>
    )
  }}
  </Consumer>)
}

